// libs
import React, { memo, useEffect, useRef } from 'react';

// styles
import { Button, ButtonV2, Container, StockInfoV2 } from './styles';

// components
import StockInfo from './StockInfo';

// defs
interface ISizeButtonProps {
  onClick: VoidFunction;
  isSelected?: boolean;
  isOutOfStock?: boolean;
  size: string;
  containerRef: React.RefObject<HTMLDivElement>;
  stockRemaining?: number;
  finalWidth?: number;
  isSizeButtonV2?: boolean;
}

const SCROLL_PADDING = 40; // left and right gutters

function SizeButton({
  onClick,
  size,
  containerRef,
  isOutOfStock = false,
  isSelected = false,
  stockRemaining,
  finalWidth = 0,
  isSizeButtonV2 = false,
}: ISizeButtonProps) {
  const elRef = useRef<HTMLButtonElement>(null);

  /**
   * Selected Size option to be visible to user
   * as size container is horizontally scrollable
   */
  useEffect(() => {
    if (isSelected === false || elRef.current === null || containerRef.current === null) {
      return;
    }

    const { left: elLeft, top: elTop, height: elHeight } = elRef.current.getBoundingClientRect();

    const {
      width: contWidth,
      left: contLeft,
      bottom,
      top,
    } = containerRef.current.getBoundingClientRect();

    //for vertical scrolling
    const isVisible = elTop + elHeight < bottom;

    if (!isVisible) {
      containerRef.current.scrollBy(0, elTop - top);
      return;
    }

    // if element already visible dont do anything
    if (elLeft < contWidth) {
      return;
    }

    containerRef.current.scrollBy(elLeft - contLeft + SCROLL_PADDING, 0);
  }, [containerRef, isSelected]);

  return (
    <Container ref={elRef} className="size-btn">
      {isSizeButtonV2 ? (
        <>
          <ButtonV2
            selected={isSelected}
            onClick={onClick}
            data-test="size-btn"
            data-at="size-btn"
            label={size}
            size="small"
            type="button"
            width={finalWidth}
          >
            {size}
          </ButtonV2>
          <StockInfoV2 isOutOfStock={isOutOfStock} stockRemaining={stockRemaining} />
        </>
      ) : (
        <>
          <Button
            selected={isSelected}
            onClick={onClick}
            data-test="size-btn"
            data-at="size-btn"
            label={size}
            size="small"
            type="button"
          >
            {size}
          </Button>
          <StockInfo isOutOfStock={isOutOfStock} stockRemaining={stockRemaining} />
        </>
      )}
    </Container>
  );
}

export default memo(SizeButton);
